import script from "./DetectKiprog.vue?vue&type=script&setup=true&lang=js"
export * from "./DetectKiprog.vue?vue&type=script&setup=true&lang=js"

import "./DetectKiprog.vue?vue&type=style&index=0&id=19461b4b&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19461b4b"]])

export default __exports__